/**
Project: Voice Panel (c)
Title: Summary 
Description: Component to show the summary of the Voice setup
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import { Text, Button } from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import { setVoiceSetupProgressPage } from "../actions/voice-setup-actions";
import { VoiceAdminURLProps } from "../../common/settings/voice-admin-urls";

class Summary extends Component {
  _isMounted = false;
  _intl_ns_vpa_voicesetup = "vpa_voicesetup";

  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadNextPage = async () => {
    this.props.history.push(VoiceAdminURLProps.home);
  };

  render() {
    return (
      <Grid fluid className="page-grid m-t-15">
        <Row>
          <Col xs={12} className="m-b-20">
            <Text className="page-heading4">
              {IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.summary.activationComplete"
              )}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="m-b-20">
            <Text className="page-text">
              {IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.summary.tabInfo"
              )}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="m-b-10">
            <Text className="page-text">
              {IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.summary.routingTabInfo"
              )}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="m-b-10">
            <Text className="page-text">
              {IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.summary.usersTabInfo"
              )}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="m-b-15">
            <Text className="page-text">
              {IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.summary.serviceNumbersTabInfo"
              )}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="m-t-20 m-b-20">
            <Button
              primary
              content={IntlUtil.getText(
                this._intl_ns_vpa_voicesetup,
                "content.done"
              )}
              onClick={this.loadNextPage}
              className="vpa-voice-setup-button"
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  voiceSetupProgressPage: state.voiceSetupStore.voiceSetupProgressPage,
});

const mapActionToProps = {
  setVoiceSetupProgressPage,
};

export default connect(mapStateToProps, mapActionToProps)(Summary);
